export const customSelectStyles = {
    control: (provided) => ({
        ...provided,
        boxShadow: "none",
        padding: "2px 4px",
        backgroundColor: "transparent",
        border: "1px solid var(--bs-card-border, #dee2e6) !important",
        borderRadius: "0.375rem",
        fontSize: "1rem",
        fontFamily: "inherit",
        width: "100%",
        outline: "none"
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "var(--bs-placeholder, #6c757d)",
        fontSize: "0.875rem"
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "inherit",
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? "var(--bs-primary, #0d6efd)"
            : state.isFocused
                ? "var(--bs-light, #f8f9fa)"
                : "transparent",
        color: state.isSelected ? "white" : "inherit",
        padding: "10px",
    }),
    menu: (provided) => ({
        ...provided,
        border: "1px solid var(--bs-card-border, #ced4da)",
        borderRadius: "0.375rem",
        boxShadow: "0 0.25rem 0.75rem rgba(0, 0, 0, 0.1)",
    }),
};